export enum SurveyQuestionType {
  single_choice = 'single_choice',
  multiple_choice = 'multiple_choice',
  short_text = 'short_text',
  long_text = 'long_text'
}
